<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div
  *ngIf="product.priceInfo"
  class="product-price-container">
  <render-wysiwyg
    class="original-product-price"
    *ngIf="isVisibleOriginalPrice"
    [html]="getTextOriginalProductPrice()"
    [piece]="piece">
  </render-wysiwyg>
  <render-wysiwyg
    *ngIf="isVisibleOldPrice"
    class="old-product-price"
    [html]="getTextOldProductPrice(false)"
    [piece]="piece">
  </render-wysiwyg>
  <div class="product-price-current-container">
    <render-wysiwyg
    class="product-price-current"
    [html]="getTextProductPrice(false, product | isCurrentPriceOnSale:this.piece!.settings!.general.displayOldProductPrices)"
    [piece]="piece">
  </render-wysiwyg>

    <render-wysiwyg
      *ngIf="isVisibleProductPriceDiscount"
      class="product-price-current"
      [html]="getProductPriceDiscountTextFormat()"
      [piece]="piece">
    </render-wysiwyg>
  </div>
</div>
<div
  *ngIf="product.priceInfo?.localePriceWithCurrencySymbol"
  class="price-locale-container">
  <render-wysiwyg
    class="locale-product-price"
    [html]="getTextProductPrice(true)"
    [piece]="piece">
  </render-wysiwyg>
  <render-wysiwyg
    *ngIf="isVisibleOldPrice && product.priceInfo!.oldLocalePriceWithCurrencySymbol"
    class="old-locale-product-price"
    [html]="getTextOldProductPrice(true)"
    [piece]="piece">
  </render-wysiwyg>
</div>
<div
  class="future-product-price-container"
  *ngIf="isVisibleFuturePrice">
  <render-wysiwyg
    class="future-product-price"
    [html]="getTextFutureProductPrice(false)">
  </render-wysiwyg>
  <render-wysiwyg
    *ngIf="product.priceInfo?.prewarming?.localePriceWithCurrency"
    class="locale-future-product-price"
    [html]="getTextFutureProductPrice(true)">
  </render-wysiwyg>
  <render-wysiwyg
    *ngIf="isVisiblePrewarmingDiscountRate"
    class="product-prewarming-discount-rate"
    [html]="getTextProductPrewarmingDiscountRate()">
  </render-wysiwyg>
  <render-wysiwyg
    *ngIf="isVisiblePrewarmingDescription"
    class="product-prewarming-description"
    [html]="getTextProductPrewarmingDescription()">
  </render-wysiwyg>
</div>
<ng-container *ngIf="isVisiblePriceDescription">
  <render-wysiwyg
    *ngIf="piece?.settings?.general?.productPriceDescription"
    [html]="piece!.settings!.general!.productPriceDescription">
  </render-wysiwyg>
</ng-container>
